import React from "react";
import { LegalPage } from "@/components/LegalPage";

export const PrivacyPolicyPage: React.FC = () => (
  <LegalPage
    title="Privacy Policy"
    lastUpdated="September 16, 2026"
    intro='Feingold Property Management, LLC ("Feingold", "we", "us") respects your privacy. This Privacy Policy explains what information we collect, how we use it, and the choices you have. By using our website and services, you agree to the practices described below.'
    sections={[
      {
        heading: "Information We Collect",
        body: (
          <p>
            We collect information you provide directly to us, such as your
            name, email address, phone number, and property details when you
            request a consultation, submit a form, or engage our services. We
            also collect limited technical information automatically, including
            browser type, device, and pages visited, to improve site performance
            and user experience.
          </p>
        ),
      },
      {
        heading: "How We Use Information",
        body: (
          <p>
            We use the information we collect to respond to inquiries, provide
            property management services, send operational communications
            related to your property, improve our website, and comply with
            applicable legal obligations. We do not sell your personal
            information to third parties.
          </p>
        ),
      },
      {
        heading: "Information Sharing",
        body: (
          <p>
            We may share information with trusted service providers who assist
            us in operating our business (such as payment processors and tenant
            screening services), when required by law, or in connection with a
            business transfer. All such providers are bound by confidentiality
            obligations.
          </p>
        ),
      },
      {
        heading: "Data Security",
        body: (
          <p>
            We implement reasonable technical and organizational safeguards to
            protect your information. However, no method of transmission over
            the internet is completely secure, and we cannot guarantee absolute
            security.
          </p>
        ),
      },
      {
        heading: "Your Rights",
        body: (
          <p>
            You may request access to, correction of, or deletion of your
            personal information by contacting us. Where applicable, you may
            also have rights under state privacy laws regarding your data.
          </p>
        ),
      },
      {
        heading: "Cookies",
        body: (
          <p>
            Our website may use cookies and similar technologies to enhance your
            browsing experience. You can control cookies through your browser
            settings, though disabling them may affect site functionality.
          </p>
        ),
      },
      {
        heading: "Changes to This Policy",
        body: (
          <p>
            We may update this Privacy Policy from time to time. Changes will be
            posted on this page with an updated revision date. Continued use of
            the site after changes constitutes acceptance of the revised policy.
          </p>
        ),
      },
    ]}
  />
);
